import {NormativeDocumentsAPI} from "../../api/api.js";
import {makeTree, sortArrayByID, sortArrayByName} from "../../utils/treeUtils.js";
import {createErrorNotification, createSuccessNotification} from "./notification-reducer.js";
import {downloadFile} from "../../utils/files.js";

const SET_START_LOADING = 'normativeDocumentReducer/SET_START_LOADING'
const SET_STOP_LOADING = 'normativeDocumentReducer/SET_STOP_LOADING'
const SET_FOLDER_TREE = 'normativeDocumentReducer/SET_FOLDER_TREE'
const SET_NORMATIVE_DOCUMENT_TREE = 'normativeDocumentReducer/SET_NORMATIVE_DOCUMENT_TREE'
const SET_FOLDERS = 'normativeDocumentReducer/SET_FOLDERS'
const SET_NORMATIVE_DOCUMENTS = 'normativeDocumentReducer/SET_NORMATIVE_DOCUMENTS'
const SET_NORMATIVE_CHAPTERS = 'normativeDocumentReducer/SET_NORMATIVE_CHAPTERS'
const SET_NORMATIVE_ARTICLES = 'normativeDocumentReducer/SET_NORMATIVE_ARTICLES'
const SET_CHECK_LIST_TREE = 'normativeDocumentReducer/SET_CHECK_LIST_TREE'
const SET_ID_CHECKLIST = 'normativeDocumentReducer/SET_ID_CHECKLIST'

const initialState = {
    loading: false,
    folderTree: [],
    normativeDocumentTree: [],
    folders: [],
    normativeDocuments: [],
    normativeChapters: [],
    normativeArticles: [],
    checkListId: null,
}

export const normativeDocumentsReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_START_LOADING:
            return {
                ...state,
                loading: true
            }

        case SET_STOP_LOADING:
            return {
                ...state,
                loading: false
            }

        case SET_FOLDER_TREE:
            return {
                ...state,
                folderTree: action.nodes
            }

        case SET_NORMATIVE_DOCUMENT_TREE:
            return {
                ...state,
                normativeDocumentTree: action.nodes
            }

        case SET_FOLDERS:
            return {
                ...state,
                folders: action.folders
            }

        case SET_NORMATIVE_DOCUMENTS:
            return {
                ...state,
                normativeDocuments: action.normativeDocuments
            }

        case SET_NORMATIVE_CHAPTERS:
            return {
                ...state,
                normativeChapters: action.normativeChapters
            }

        case SET_NORMATIVE_ARTICLES:
            return {
                ...state,
                normativeArticles: action.normativeArticles
            }
        case SET_CHECK_LIST_TREE:
                return {
                    ...state,
                    checkListTree: action.tree
                }
        case SET_ID_CHECKLIST:
                return {
                    ...state,
                    checkListId: action.id
                }
        default:
            return state
    }
}

export const startLoading = () => ({type: SET_START_LOADING})
export const stopLoading = () => ({type: SET_STOP_LOADING})
export const selectLoading = (state) => state.normativeDocumentsReducer.loading

export const setFolderTree = (nodes) => ({type: SET_FOLDER_TREE, nodes})
export const selectFolderNodes = (state) => state.normativeDocumentsReducer.folderTree

export const setNormativeDocumentTree = (nodes) => ({type: SET_NORMATIVE_DOCUMENT_TREE, nodes})
export const selectNormativeDocumentTree = (state) => state.normativeDocumentsReducer.normativeDocumentTree

export const setFolders = (folders) => ({type: SET_FOLDERS, folders})
export const selectFolders = (state) => state.normativeDocumentsReducer.folders

export const setNormativeDocuments = (normativeDocuments) => ({type: SET_NORMATIVE_DOCUMENTS, normativeDocuments})
export const selectNormativeDocuments = (state) => state.normativeDocumentsReducer.normativeDocuments

export const setNormativeChapters = (normativeChapters) => ({type: SET_NORMATIVE_CHAPTERS, normativeChapters})
export const selectNormativeChapters = (state) => state.normativeDocumentsReducer.normativeChapters

export const setNormativeArticles = (normativeArticles) => ({type: SET_NORMATIVE_ARTICLES, normativeArticles})
export const selectNormativeArticles = (state) => state.normativeDocumentsReducer.normativeArticles

export const setCheckListTree = (tree) => ({type: SET_CHECK_LIST_TREE, tree})
export const checkListSelector = (state) => state.normativeDocumentsReducer

export const getCheckListInfo = (state) => state.normativeDocumentsReducer
export const checkListIdAction = (id) => ({type: SET_ID_CHECKLIST, id})
export const getCheckListId = (state) => state.normativeDocumentsReducer


export const getFolderNodes = () => async (dispatch) => {
    const foldersResponse = await NormativeDocumentsAPI.getDocumentFolders()
    const normativeDocumentsResponse = await NormativeDocumentsAPI.getNormativeDocuments()

    

    const folders = foldersResponse.data
        .map(folder => ({...folder, type: 'folder'}))
        .sort(sortArrayByName())

    const normativeDocuments = normativeDocumentsResponse.data
        .map(doc => ({...doc, type: 'normativeDocument'}))
        .sort(sortArrayByName())

 

    const config = [
        {
            parentPosition: 0,
            parentKey: 'folder',
            root: true,
            rootValue: null
        },
        {
            parentPosition: 0,
            parentKey: 'folder',
            root: true,
            rootValue: null
        },
    ]

    dispatch(setFolderTree(makeTree([folders, normativeDocuments], config)))
    dispatch(setFolders(folders))
    dispatch(setNormativeDocuments(normativeDocuments))
}


export const getNormativeDocumentNodes = (normativeDocumentID) => async (dispatch) => {
    dispatch(startLoading())

    const chaptersResponse = await NormativeDocumentsAPI.getNormativeChapters(normativeDocumentID)
    const articlesResponse = await NormativeDocumentsAPI.getNormativeArticles(normativeDocumentID)

    const chapters = chaptersResponse.data
        .map(chapter => ({...chapter, type: 'normativeChapter'}))

    const articles = articlesResponse.data
        .map(article => ({
            ...article,
            type: 'normativeArticle',
            name: <div><strong>Номер пункта:</strong> {article.number}<br/>
                <strong>Краткое название:</strong> {article.short_text}<br/>
                <strong>Полное название:</strong> {article.full_text}</div>
        }))
        .sort(sortArrayByID)
    
    const config = [
        {
            parentPosition: 0,
            parentKey: 'normative_chapter',
            root: true,
            rootValue: null
        },
        {
            parentPosition: 0,
            parentKey: 'normative_chapter',
            root: true,
            rootValue: null
        },
    ]

    dispatch(setNormativeDocumentTree(makeTree([chapters, articles], config)))
    dispatch(setNormativeChapters(chapters))
    dispatch(setNormativeArticles(articles))

    dispatch(stopLoading())
}

export const createFolder = (values) => async () => {
    await NormativeDocumentsAPI.createDocumentFolder(values)
}

export const updateFolder = (values) => async () => {
    await NormativeDocumentsAPI.updateDocumentFolder(values.id, values)
}

export const createNormativeChapter = (values) => async () => {
    await NormativeDocumentsAPI.createNormativeChapter(values)
}

export const updateNormativeChapter = (values) => async () => {
    await NormativeDocumentsAPI.updateNormativeChapter(values.id, values)
}

export const createNormativeArticle = (values) => async () => {
    await NormativeDocumentsAPI.createNormativeArticle(values)
}

export const updateNormativeArticle = (values) => async () => {
    await NormativeDocumentsAPI.updateNormativeArticle(values.id, values)
}

export const updateNormativeDocument = (values) => async () => {
    let data
    if (typeof values.file === 'object' && values.file !== null) {
        data = new FormData()
        data.append('name', values.name)
        data.append('file', values.file.file)
    } else {
        data = {name: values.name}
    }
    if (values.file === undefined) data = {...data, file: null}
    await NormativeDocumentsAPI.updateNormativeDocument(values.id, data)
}

export const downloadNormativeDocument = (documentID) => async () => {
    await downloadFile(NormativeDocumentsAPI.downloadNormativeDocument(documentID))
}

export const moveFolderTreeElement = (nodeID, folderID) => async (dispatch) => {
    const [type, id] = nodeID.split('.')

    if (type === 'folder' && parseInt(id) === folderID) {
        await dispatch(createErrorNotification('Нельзя вставить папку саму в себя :)'))
        return null
    }

    if (type === 'folder') {
        await NormativeDocumentsAPI.updateDocumentFolder(id, {folder: folderID})
    }

    if (type === 'normativeDocument') await NormativeDocumentsAPI.updateNormativeDocument(id, {folder: folderID})

    await dispatch(createSuccessNotification('Успешная вставка'))
}

export const moveNormativeDocumentTreeElement = (nodeID, chapterID) => async (dispatch) => {
    const [type, id] = nodeID.split('.')

    if (type === 'normativeChapter' && parseInt(id) === chapterID) {
        await dispatch(createErrorNotification('Нельзя вставить главу саму в себя :)'))
        return null
    }

    if (type === 'normativeArticle' && chapterID === null){
        await dispatch(createErrorNotification('Нельзя переместить пункт в корень документа'))
        return null
    }

    if (type === 'normativeChapter') {
        await NormativeDocumentsAPI.updateNormativeChapter(id, {normative_chapter: chapterID})
    }

    if (type === 'normativeArticle') await NormativeDocumentsAPI.updateNormativeArticle(id, {normative_chapter: chapterID})

    await dispatch(createSuccessNotification('Успешная вставка'))
}

export const deleteElement = (nodeID) => async (dispatch) => {
    dispatch(startLoading())

    const [type, id] = nodeID.split('.')

    if (type === 'folder') await NormativeDocumentsAPI.deleteDocumentFolder(id)

    if (type === 'normativeDocument') await NormativeDocumentsAPI.deleteNormativeDocument(id)

    if (type === 'normativeChapter') await NormativeDocumentsAPI.deleteNormativeChapter(id)

    if (type === 'normativeArticle') await NormativeDocumentsAPI.updateNormativeArticle(id, {deleted: true})

    dispatch(stopLoading())
}

export const uploadExcelNormativeDocument = (file, folderID, onSuccess) => async (dispatch) => {
    dispatch(startLoading())
    try {
        
        const response = await NormativeDocumentsAPI.uploadExcelNormativeDocument(file, folderID)
        
        onSuccess()
    } catch (e) {
        dispatch(createErrorNotification(e.response.data))
    }
    dispatch(stopLoading())
}

export const uploadCheckLIstInfo = (file) => async (dispatch) => {
    dispatch(startLoading())
    try {
        const response = await NormativeDocumentsAPI.uploadCheckLIstInfo(file)
        const id = response.data.id
        dispatch(checkListIdAction(id))
    
        if (response.status === 201) {
            const articlesResponse = await NormativeDocumentsAPI.getExcelCheckListArticles(id)
            const chaptersResponse = await NormativeDocumentsAPI.getExcelCheckListChapters(id)

          

            const chapters = chaptersResponse.data
                .map(chapter => ({...chapter, type: 'normativeChapter'}))

            const articles = articlesResponse.data.results
                .map(article => ({
                    ...article,
                    type: 'normativeArticle',
                    name: <div><strong>Номер пункта:</strong> {article.number}<br/>
                        <strong>Полное название:</strong> {article.full_text}</div>
                }))
                .sort(sortArrayByID)

        

            const config = [
                {
                    parentPosition: 0,
                    parentKey: 'excel_chapter',
                    root: true,
                    rootValue: null
                },
                {
                    parentPosition: 0,
                    parentKey: 'excel_chapter',
                    root: true,
                    rootValue: null
                },
            ]

            dispatch(setNormativeDocumentTree(makeTree([chapters, articles], config)))
            dispatch(setNormativeChapters(chapters))
            dispatch(setNormativeArticles(articles))
        }
    } catch (e) {
        dispatch(createErrorNotification(e.response))
    }
    dispatch(stopLoading())
}

export const getExcelDocumentNodes = (id) => async (dispatch) => {
    dispatch(startLoading())
        try {
        
            const articlesResponse = await NormativeDocumentsAPI.getExcelCheckListArticles(id)
            const chaptersResponse = await NormativeDocumentsAPI.getExcelCheckListChapters(id)

          

            const chapters = chaptersResponse.data
                .map(chapter => ({...chapter, type: 'normativeChapter'}))

            const articles = articlesResponse.data.results
                .map(article => ({
                    ...article,
                    type: 'normativeArticle',
                    name: <div><strong>Номер пункта:</strong> {article.number}<br/>
                        <strong>Полное название:</strong> {article.full_text}</div>
                }))
                .sort(sortArrayByID)

        

            const config = [
                {
                    parentPosition: 0,
                    parentKey: 'excel_chapter',
                    root: true,
                    rootValue: null
                },
                {
                    parentPosition: 0,
                    parentKey: 'excel_chapter',
                    root: true,
                    rootValue: null
                },
            ]

            dispatch(setNormativeDocumentTree(makeTree([chapters, articles], config)))
            dispatch(setNormativeChapters(chapters))
            dispatch(setNormativeArticles(articles))
        
    } catch (e) {
        dispatch(createErrorNotification(e.response))
    }
    dispatch(stopLoading())
}

export const createNormativeDocument = (folderID, onSuccess) => async (dispatch) => {
    dispatch(startLoading())
    try{
        await NormativeDocumentsAPI.createNormativeDocument({
            name: 'Новый документ',
            folder: folderID
        })
        onSuccess()
    } catch (e) {
        dispatch(createErrorNotification(e.response.data))
    }
    dispatch(stopLoading())


}


